import React, { Component, PropTypes } from 'react'

import { isSameDay, range, isBetween } from 'utils/datetime'
import DateRangePicker from './date-range-picker'

class DateRangePickerContainer extends Component {

  constructor(props) {
    super(props)

    this.state = {
      startDate: null,
      endDate: null,
    }

    this.handleCancel = this.handleCancel.bind(this)
    this.handleSave = this.handleSave.bind(this)
    this.handleDayClick = this.handleDayClick.bind(this)
    this.isStartDate = this.isStartDate.bind(this)
    this.isEndDate = this.isEndDate.bind(this)
    this.isInSelectedSpan = this.isInSelectedSpan.bind(this)
  }

  handleCancel() {
    this.setState({
      startDate: null,
      endDate: null,
    }, this.props.onClose)
  }

  handleSave() {
    if (this.state.startDate && this.state.endDate) {
      const dates = range(this.state.startDate, this.state.endDate).map(date => this.props.format(date))

      this.props.onChange(this.props.dates.concat(dates))
      this.handleCancel()
    } else {
      this.props.onClose()
    }
  }

  handleDayClick(date) {
    if (this.state.startDate) {
      if (this.state.endDate) {
        this.setState({
          startDate: date,
          endDate: null,
        })
      } else {
        this.setState({
          endDate: date,
        })
      }
    } else {
      this.setState({
        startDate: date,
      })
    }
  }

  isStartDate(date) {
    return isSameDay(date, this.state.startDate)
  }

  isEndDate(date) {
    return isSameDay(date, this.state.endDate)
  }

  isInSelectedSpan(date) {
    return isBetween(date, this.state.startDate, this.state.endDate)
  }

  render() {
    return (
      <DateRangePicker
        {...this.props}
        {...this.state}
        onCancel={this.handleCancel}
        onSave={this.handleSave}
        onDayClick={this.handleDayClick}
        isStartDate={this.isStartDate}
        isEndDate={this.isEndDate}
        isInSelectedSpan={this.isInSelectedSpan}
      />
    )
  }

}

DateRangePickerContainer.propTypes = {
  dates: PropTypes.array,
  format: PropTypes.func,
  onChange: PropTypes.func,
  onClose: PropTypes.func,
}

export default DateRangePickerContainer



/** WEBPACK FOOTER **
 ** ./src/components/date-range-picker/date-range-picker-container.js
 **/